// extracted by mini-css-extract-plugin
export default {"accordionButton":"Common_accordionButton__88Z9o","accordionPanel":"Common_accordionPanel__j9Fhs","expand":"Common_expand__TKv4I","styles":"Common_styles__ovVcr"};